module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="wrapper">\r\n   \r\n</div>\r\n\r\n<!-- Modal -->\r\n<div class="modal fade" id="insertModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">\r\n\r\n</div>\r\n\r\n<!-- Modal -->\r\n<div class="modal fade" id="insertModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">\r\n\r\n</div>\r\n\r\n<div id="hiddenRegion" class="hidden">\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/mainView.ejs
// module id = 427
// module chunks = 0